<template>
  <section id="company" class="rt-section company">
    <div class="rt-inner">
      <div class="rt-section-head">
        <span class="rt-eyebrow company__eyebrow">COMPANY</span>
        <h2 class="rt-section-title">会社概要</h2>
      </div>

      <dl class="company__table">
        <div class="company__row">
          <dt>名称</dt>
          <dd>東京ライツサービス株式会社</dd>
        </div>
        <div class="company__row">
          <dt>所在地</dt>
          <dd>
            東京都渋谷区代々木一丁目30番14号 天翔オフィス代々木ANNEX207<br>
            <a href="https://goo.gl/maps/tgiKgLxA24YU6BG89" target="_blank" rel="noopener noreferrer" aria-label="所在地を地図で見る（新しいタブで開きます）" class="company__map">
              <i class="fas fa-map-location-dot" aria-hidden="true"></i> 地図で見る
            </a>
          </dd>
        </div>
        <div class="company__row">
          <dt>設立</dt>
          <dd>2018年6月</dd>
        </div>
        <div class="company__row">
          <dt>資本金</dt>
          <dd>5,000,000円</dd>
        </div>
        <div class="company__row">
          <dt>代表者</dt>
          <dd>代表取締役 松崎史崇</dd>
        </div>
        <div class="company__row">
          <dt>主な事業内容</dt>
          <dd>
            <ul class="company__list">
              <li>各種印税管理システムの開発</li>
              <li>各種印税管理システムの運営</li>
              <li>印税計算業務の作業代行</li>
            </ul>
          </dd>
        </div>
      </dl>
    </div>
  </section>
</template>

<script>
export default { name: 'HomeCompany' }
</script>

<style scoped>
.company {
  background: var(--base);
}

.company__eyebrow {
  color: var(--brand-green);
  background: var(--green-bg);
}

.company__table {
  max-width: 680px;
  margin: 0 auto;
  text-align: left;
}

.company__row {
  display: flex;
  gap: 16px;
  padding: 14px 0;
  border-bottom: 1px solid var(--line);
}

.company__row dt {
  width: 120px;
  flex-shrink: 0;
  font-size: 13px;
  color: var(--ink-mute);
}

.company__row dd {
  margin: 0;
  font-size: 14px;
  color: var(--ink);
}

.company__map {
  display: inline-block;
  margin-top: 8px;
  font-size: 12px;
  color: var(--brand-blue);
  text-decoration: none;
}

.company__list {
  margin: 0;
  padding-left: 18px;
}

@media (max-width: 768px) {
  .company__row {
    flex-direction: column;
    gap: 4px;
  }

  .company__row dt {
    width: auto;
  }
}
</style>
